import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marca una llamada a un API PÚBLICO ajeno a la app (USGS, Open-Meteo…): el interceptor la
 * deja pasar tal cual, sin JWT, sin llaves ni cabeceras propias. Esas cabeceras no solo
 * sobran: disparan un preflight CORS que esos servicios no aceptan.
 */
export const PUBLIC_REQUEST = new HttpContextToken<boolean>(() => false);

/** Contexto listo para `http.get(url, { context: publicRequestContext() })`. */
export function publicRequestContext(): HttpContext {
    return new HttpContext().set(PUBLIC_REQUEST, true);
}
